(function () {
  /**
   * @deprecated Please use src2/core/services/contact/ContactList.js
   *
   * @ngdoc factory
   * @name binky.core.contact:ContactList
   * @description Model for a contact list
   */
  angular.module('binky.core.contact').factory('ContactList', ContactListModel);

  /* @ngInject */
  function ContactListModel(
    $log,
    $q,
    $rootScope,
    _,
    apiUtils,
    binkySrc2,
    Contact,
    CONTACT_LIST_CACHE_ID,
    CONTACT_LIST_EVENT,
    CONTACT_TYPE,
    feature,
    jilContacts,
    modelCache,
    modelCacheUtils,
    promiseUtils
  ) {
    /**
     * @deprecated This class has been ported to src2.
     * Any subsequent changes should be made to the src2 implementation.
     */
    class ContactList {
      /**
       * @description Creates a new ContactList for use.
       *
       * @param {Object} options Initialization Object (see updateModel for detail)
       */
      constructor(options = {}) {
        this.orgId = options.orgId;
        updateModel(this, options);
      }

      /**
       * @return {boolean} true if all contacts are complete
       */
      isAllContactsComplete() {
        return (
          this.dataAccessAdministrator.isComplete() &&
          this.dataProtectionOfficer.isComplete() &&
          this.securityOfficer.isComplete()
        );
      }

      /**
       * @return {boolean} true if all contacts are empty
       */
      isAllContactsEmpty() {
        return (
          this.dataAccessAdministrator.isEmpty() &&
          this.dataProtectionOfficer.isEmpty() &&
          this.securityOfficer.isEmpty()
        );
      }

      /**
       * @return {boolean} true if any contacts are partially complete
       */
      isContactsPartiallyComplete() {
        return !this.isAllContactsComplete() && !this.isAllContactsEmpty();
      }

      /**
       * @description Key for caching, based on org ID.
       * @returns {String} key for caching
       */
      key() {
        return modelCacheUtils.getParameterizedKey({
          orgId: _.get(this, 'orgId', apiUtils.getActiveOrg()),
        });
      }

      /**
       * @description Method to refresh the contents of the list
       *
       * @returns {Promise} promise - resolved when the list is refreshed
       */
      refresh() {
        this.$resolved = false;

        this.$promise = jilContacts.contacts
          .get(this.orgId ? {orgId: this.orgId} : undefined)
          .$promise.then(onSuccess.bind(this))
          .finally(() => {
            this.$resolved = true;
          });

        function onSuccess(contacts) {
          updateModel(this, contacts);
          modelCache.put(CONTACT_LIST_CACHE_ID, this, this.key());
          $rootScope.$emit(CONTACT_LIST_EVENT.REFRESH);
          return this;
        }

        return this.$promise;
      }

      /**
       * @description Method to overwrite the current ContactList with the newContactInfo.
       *
       * @param {ContactList} newContactInfo - the ContactList to be overwritten with
       *
       * @returns {Promise} resolves if changes successfully saved, else rejects with error message
       */
      save(newContactInfo) {
        if (!hasUnsavedChanges(this, newContactInfo)) {
          return $q.resolve(this);
        }

        this.$resolved = false;
        this.$promise = jilContacts.contacts
          .update(
            _.reduce(
              CONTACT_TYPE,
              (result, type) => {
                result[type] = newContactInfo[type];
                return result;
              },
              {}
            )
          )
          .$promise.then(onSuccess.bind(this))
          .catch(onError.bind(this))
          .finally(() => {
            this.$resolved = true;
          });

        function onSuccess(contacts) {
          updateModel(this, contacts);
          modelCache.put(CONTACT_LIST_CACHE_ID, this, this.key());
          $rootScope.$emit(CONTACT_LIST_EVENT.REFRESH);
          return this;
        }

        function onError(error) {
          $log.error('Failed to create/update contacts. Error: ', error);
          return $q.reject(error);
        }

        return this.$promise;
      }

      /**
       * @description Method to fetch the ContactList. It will be refreshed on
       *     registering the active org
       * @param {Object} options - options to configure the contract list, may be undefined
       * @param {Object} [options.orgId] - ID of org of which contracts should be fetched.
       * @returns {ContactList} singleton ContactList.
       */
      static get(options) {
        let model = new ContactList(options);
        const cachedModel = modelCache.get(CONTACT_LIST_CACHE_ID, model.key());

        if (cachedModel) {
          model = cachedModel;
        } else {
          model.refresh();
        }
        return model;
      }
    }

    // We register the cache size for this class
    modelCache.register(CONTACT_LIST_CACHE_ID, 1);

    /** Private Methods **/

    /**
     * @description Initializes contact list.
     *
     * @param {Object} model ContactList model Object instance to initialize
     * @param {Object} options initialization object
     * @param {Object} options.dataAccessAdministrator dataAccessAdministrator's contact info
     * @param {Object} options.dataProtectionOfficer dataProtectionOfficer's contact info
     * @param {Object} options.securityOfficer securityOfficer's contact info
     */
    function updateModel(model, options) {
      _.assign(model, {
        dataAccessAdministrator: new Contact(options.dataAccessAdministrator),
        dataProtectionOfficer: new Contact(options.dataProtectionOfficer),
        securityOfficer: new Contact(options.securityOfficer),
      });

      // setup model as already resolved which ensures it can be used
      model.$resolved = true;
      model.$promise = $q.resolve(model);
    }

    class ContactList2 extends binkySrc2.services.contact.ContactList {
      constructor(options = {}) {
        super(options);
      }

      refresh() {
        this.$resolved = false;

        this.$promise = promiseUtils.toAngularPromise(super.refresh()).finally(() => {
          this.$resolved = true;
        });
        return this.$promise;
      }

      save(newContactInfo) {
        this.$resolved = false;

        this.$promise = promiseUtils.toAngularPromise(super.save(newContactInfo)).finally(() => {
          this.$resolved = true;
        });
        return this.$promise;
      }

      static get(options = {}) {
        const model = new ContactList2(options);
        model.refresh();
        return model;
      }
    }

    return feature.isEnabled('temp_react_port_contact_list') ? ContactList2 : ContactList;

    /** Private Methods **/

    /**
     * @description Compare if there is difference between the two contact lists
     * @param {ContactList} list1 - the original ContactList
     * @param {ContactList} list2 - the new ContactList
     * @return {boolean} true if there are difference
     */
    function hasUnsavedChanges(list1, list2) {
      return _.some(CONTACT_TYPE, (type) => !_.isEqual(list1[type], list2[type]));
    }
  }
})();
